import { styled } from "@mui/material/styles";

export const StyledContainer = styled("div")(({ theme }) => ({
  padding: theme.spacing(1),
  paddingBottom: theme.spacing(8),
  justifyContent: "left"
}));

export const StyledHeader = styled("div")(({ theme }) => ({
  justifyContent: "left",
  width: "30%"
}));
